import { render, staticRenderFns } from "./MWithoutDataComp.vue?vue&type=template&id=247c77e4&"
import script from "./MWithoutDataComp.vue?vue&type=script&lang=js&"
export * from "./MWithoutDataComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports